import { render, staticRenderFns } from "./PaymentDetailsTypeFGTS.vue?vue&type=template&id=4b1f1673"
import script from "./PaymentDetailsTypeFGTS.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsTypeFGTS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports